import APIEndpoints from '@utils/APIEndpoints';
import { useCallback } from 'react';
import { useRequestState } from './useRequestState';
import axios, { AxiosError } from 'axios';
import get from 'lodash/get';
import { logoutWarranty } from '@utils/auth';
import { useRouter } from 'next/router';
import { getWarrantyPageRoute } from '@utils/routeConstants';
import { tryParse } from '@utils/formatter';

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

// #TODO : use fetch instead of axios
export function useApiRequest<Resp = unknown, Body = void>(path: string, method: HttpMethod = 'POST') {
  const { setError, setLoading, setData, state } = useRequestState<Resp, string>();
  const router = useRouter();

  const fn = useCallback(
    async (body: Body) => {
      setLoading(true);

      try {
        const payload = JSON.stringify(body);

        const data = await executeFetchRequest<Resp>(path, payload, method);
        setData(data);
      } catch (error) {
        setError(get(error, 'response.data.messages'));

        const err = error as AxiosError;
        console.log(err);

        if (err.response?.status === 401) {
          logoutWarranty();
          router.push(getWarrantyPageRoute('dang-nhap'));
        }
        return Promise.reject(error);
      }
    },
    [path, method, setLoading, setData, setError],
  );

  return [fn, state] as [typeof fn, typeof state];
}

async function executeFetchRequest<Resp = unknown>(url: string, payload: string, method = 'POST') {
  const authObject = tryParse(localStorage.getItem('w-auth') || '');
  const token = authObject?.token || '';

  const options: RequestInit = {
    method,
    headers: {
      accept: 'application/json',
      'Content-Type': 'application/json',
      credentials: 'include',
    },
  };

  const methodsSupportingBody: HttpMethod[] = ['POST', 'PUT', 'PATCH'];

  const supportsBody = methodsSupportingBody.includes(method as HttpMethod);

  if (payload && supportsBody) {
    options.body = payload;
  }

  url = APIEndpoints.WARRANTY_URL + '/api/v1/' + url;
  try {
    const dataPayload = payload ? JSON.parse(payload) : null;
    const response = await axios({
      url: url,
      method: method,
      withCredentials: true,
      params: method === 'GET' ? dataPayload : null,
      data: supportsBody ? dataPayload : null,
      headers: { Authorization: `Bearer ${token}` },
    });

    if (response.status === 200) {
      return (await response.data.data) as Promise<Resp>;
    }

    // const response = await fetch(url, options);

    // if (response.ok) {
    //   return (await response.json()) as Promise<Resp>;
    // }

    return Promise.reject(response.statusText);
  } catch (e: unknown) {
    // const err = e as AxiosError;
    // console.log(err);
    // const status = err.response.status;
    return Promise.reject(e);
  }
}
